import { formatClockTime } from '../../../../lib/formatDate';

/** `10:00 AM – 11:30 AM`, or the start alone where nobody set an end. One helper for every surface. */
export function timeRange(record: { startTime: string; endTime?: string | null }): string {
  return record.endTime != null
    ? `${formatClockTime(record.startTime)} – ${formatClockTime(record.endTime)}`
    : formatClockTime(record.startTime);
}
